import { gql } from '@apollo/client';
export const validateWithdrawalAddressQuery = gql `
  query validateWithdrawalAddress($record: ValidateWithdrawalAddressRecord!) {
    validateWithdrawalAddress(record: $record)
  }
`;
//# sourceMappingURL=validateWithdrawalAddress.js.map